import styles from './bottom-navigation.module.scss';
import MaterialBottomNavigation from '@mui/material/BottomNavigation';
import MaterialBottomNavigationAction from '@mui/material/BottomNavigationAction';
import { ReactNode } from 'react';

/* eslint-disable-next-line */
export interface BottomNavigationProps {
  children?: any,
  // classes?: object,
  component?: any,
  onChange?: (event: any, value: any) => void,
  showLabels?: boolean,
  sx?: any,
  value?: any
}

export interface BottomNavigationActionProps {
  // classes?: object,
  icon?: ReactNode,
  label: ReactNode,
  showLabel?: boolean,
  sx?: any,
  value?: any
}

export function BottomNavigation(props: BottomNavigationProps) {
  return (
    <MaterialBottomNavigation
      showLabels={props.showLabels}
      value={props.value}
      onChange={props.onChange}
      sx={props.sx}
      component={props.component}>
      {props.children}
    </MaterialBottomNavigation>
  );
}

export function BottomNavigationAction(props: BottomNavigationActionProps) {
  return (
    <MaterialBottomNavigationAction
      label={props.label}
      icon={props.icon}
      showLabel={props.showLabel}
      value={props.value}
      sx={props.sx}
    />
  );
}

export default BottomNavigation;